
function isElementInViewport(el) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }
  var rect = el.getBoundingClientRect();
  return rect.top < window.innerHeight;
}
function onVisibilityChange(el, callback) {
  var old_visible;
  return function() {
    var visible = isElementInViewport(el);
    if (visible != old_visible) {
      old_visible = visible;
      if (typeof callback == "function") {
        callback(visible);
      }
    }
  };
}
function createTimeline(id) {
  const tlLeft = new TimelineMax({ paused: true }).fromTo(
    `#${id} .ani-left`,
    1,
    { x: -1000, opacity: 0 },
    { x: 0, opacity: 1 },
    0
  );

  const tlRight = new TimelineMax({ paused: true })
    .fromTo(
      `#${id} .ani-txt`,
      1,
      { scaleY: 0, opacity: 0 },
      { scaleY: 1, opacity: 1 },
      0
    )
    .fromTo(
      `#${id} .ani-right`,
      1,
      { x: 200, opacity: 0 },
      { x: 0, opacity: 1 },
      0
    )
    .fromTo(
      `#${id} .ani-bottom`,
      1,
      { y: 200, opacity: 0 },
      { y: 0, opacity: 1 },
      1.5
    )
    .fromTo(
      `#${id} .ani-bottom-immi`,
      1,
      { y: 200, opacity: 0 },
      { y: 0, opacity: 1 },
      0.2
    )
    .fromTo(
      `#${id} .ani-top`,
      1,
      { y: -200, opacity: 0 },
      { y: 0, opacity: 1 },
      0
    )
    .staggerFromTo(
      `#${id} .ani-icon`,
      1,
      { x: -100, opacity: 0 },
      { x: 0, opacity: 1, ease: Bounce.easeOut },
      0.2,
      1
    );
  const checkLeft = onVisibilityChange($(`#${id} .inner .left`), function(
    visible
  ) {
    if (visible) {
      tlLeft.restart();
    }
  });
  const checkRight = onVisibilityChange($(`#${id} .inner .right`), function(
    visible
  ) {
    if (visible) {
      tlRight.restart();
    }
  });
  return function() {
    checkLeft();
    checkRight();
  };
}

var checks = [
  "trading",
  "education",
  "rocksolid",
  "leading",
  "acquire",
  "cup",
  "fin",
  "about"
].map(createTimeline);

var handler = function() {
  checks.forEach(f => f());
};
$(window).on("DOMContentLoaded load resize scroll", handler);

document.getElementById("btn").onclick = function click() {
  document
    .getElementById("second")
    .scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
};

// promotions for anniversary
const getLocation=()=>{
  let myLocation = localStorage.getItem('gala_page');
  if (!myLocation) {
      $.get('https://ipinfo.io', function (response) {
          myLocation = response.country;
          localStorage.setItem('gala_page', myLocation);
      }, 'jsonp')
  }
  return myLocation;
}
const timeInitiator=()=>{
  let targetTime = {};
  targetTime.year = 2019;
  targetTime.month = 10;
  targetTime.date =26;
  targetTime.hour = 17;
  targetTime.minute = 00;
  targetTime.second = 00;
  return targetTime
}

// serilised time  accurate to month level 
const seriliszeTime = (day,hour, minute, second) => {
  return 24 * 3600*day+3600 * hour + 60 * minute + second;
};

const setTargetTime = targetTime => {
  let readTargetTime = `${targetTime.date}/${targetTime.month}/${targetTime.year} ${targetTime.hour}:${targetTime.minute}:${targetTime.second}`;
  let calTargetTime = seriliszeTime(
    targetTime.date,
    targetTime.hour,
    targetTime.minute,
    targetTime.second
  );
  return { readTargetTime, calTargetTime };
};

const getCurrentTime = () => {
  let time = new Date($.now());
  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  let date = time.getDate();
  let hour = time.getHours();
  let minute = time.getMinutes();
  let second = time.getSeconds();
  let readableTime = `${date}/${month}/${year} ${hour}:${minute}:${second}`;
  let calCurrentTime = seriliszeTime(date,hour, minute, second);
  return { readableTime, calCurrentTime };
};

const changeVideoSrc=(element,src)=>{
  if(element.attr("src")!== src){
    element.attr("src",src);
  }
}

const setLargerScreenHeaderImage=(deviceWidth)=>{
  if(deviceWidth>1100){
    let imageHeight=parseInt(deviceWidth/16*9);
    console.log('image width',imageHeight);
    $('#first .header-img img').attr("style",`width:${deviceWidth}px;height:${imageHeight}px;`);
  }else{
    $('#first .header-img img').attr('style',`height:100vh`);
  }
}

const setLiveStream = ({ liveUrlPcCN, liveUrlMobCN, liveUrlEn,deviceWidth,country}) => {
  let videoZone = $('#third iframe');
  let videoSrc = $("#third iframe").attr("src");
  videoZone.attr('style',`width:${deviceWidth-300}px;height:${deviceWidth-600}px;`)

  if (deviceWidth > 769) {
    videoZone.attr('style','width:1200px;height:600px');
    changeVideoSrc(videoZone,liveUrlPcCN);
  } else {
    videoZone.attr('style','width:800px;height:600px');
    changeVideoSrc(videoZone,liveUrlMobCN);
  }
};

const setCnVideo =(position,videoSrc)=>{
  $(position).append('<video class="video-wrapper video-cn" muted autoplay loop controls> <source src=' + videoSrc + ' type="video/mp4"></video>')
}

const setEnVideo=(position,videoSrc)=>{
  $(position).append(`<iframe class="video-wrapper video-en" frameborder="0" src="${videoSrc}" allowfullscreen> </iframe>`);
}

const resetVideo =(country,deviceWidth)=>{
  let positionGala =$('.gala-video-wrapper');
  let cnVideoGala = "http://1253488992.vod2.myqcloud.com/2e510092vodgzp1253488992/6b0e15e45285890795338595398/LIkkX4hej7AA.mp4";
  let enVideoGala ="https://www.youtube.com/embed/agA_l4qwjIQ?controls=1&playlist=agA_l4qwjIQ&loop=1";
  
  let positionNorm=$('#third');
  let cnVideoNorm ='http://1253488992.vod2.myqcloud.com/2e510092vodgzp1253488992/4414cbd85285890795365372870/tf1CzjYoANYA.mp4';
  let enVideoNorm ='https://www.youtube.com/embed/iCkCOsF6mAI?controls=1&playlist=iCkCOsF6mAI&loop=1';
  

  switch(country){
    case "AU":
      positionGala.attr('style','width:60%;max-width:800px;');
      setEnVideo(positionGala,enVideoGala);
      setEnVideo(positionNorm,enVideoNorm);
      break;
    case "CN":
      setCnVideo(positionGala,cnVideoGala);
      setCnVideo(positionNorm,cnVideoNorm);
      break;
    default:
        positionGala.attr('style','width:60%;max-width:800px;');
      setEnVideo(positionGala,enVideoGala);
      setEnVideo(positionNorm,enVideoNorm);
      break;
  }
}

$(window).ready(() => {
let country = getLocation();
let deviceWidth = $(window).width();

setLargerScreenHeaderImage(deviceWidth);

// let targetTime = timeInitiator();
  // let { readTargetTime, calTargetTime } = setTargetTime(targetTime);

  // setInterval(() => {
    // let { readableTime, calCurrentTime } = getCurrentTime(); 
    // if (
    //   calCurrentTime >= calTargetTime &&
    //   calCurrentTime < calTargetTime + 203
    // ) {
      // setLiveStream({liveUrlEn, liveUrlMobCN, liveUrlPcCN,deviceWidth,country });
    // }else {
      resetVideo(country,deviceWidth);
    // }
  // }, 1000);
});
